import { Instance, types } from 'mobx-state-tree';
import { BaseModel } from './_base/baseModel';
import { UserTextModel } from './userText';

export type TUserTextAreaModel = typeof UserTextAreaModel;
export type UserTextAreaModelInstance = Instance<TUserTextAreaModel>;
export interface IUserTextAreaModel extends UserTextAreaModelInstance {}

export const UserTextAreaModel = BaseModel.named('UserTextAreaModel')
  .props({
    id: types.identifier,
    productId: types.string,

    x: types.optional(types.number, 0),
    y: types.optional(types.number, 0),
    width: types.optional(types.number, 0),
    height: types.optional(types.number, 0),
    position: types.optional(types.string, 'front'),
    userText: types.maybe(types.safeReference(UserTextModel)),
  })
  .views(self => ({

  }))
  .actions(self => ({

  }));
